/**
 * Angular dependencies
 */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * Third-party dependencies
 */
import { ButtonModule, DropdownsModule, InputFieldsModule, ModalsModule } from 'gds-atom-components';

/**
 * Agents
 */
import { AgentResolver } from '@app/core/resolvers/agent.resolver';
import { AgentExampleComponent } from "@shared/components/agent-example/agent-example.component";
import { AgentBuilderComponent } from './agent-builder/agent-builder.component';
import { AgentChatNewComponent } from './agent-chat-new/agent-chat-new.component';
import { AgentConversationStarterComponent } from './agent-conversation-starter/agent-conversation-starter.component';
import { AgentCreationComponent } from './agent-creation/agent-creation.component';
import { AgentEditComponent } from './agent-edit/agent-edit.component';
import { AgentFormComponent } from './agent-form/agent-form.component';
import { AgentListPagedComponent } from './agent-list-paged/agent-list-paged.component';
import { AgentCardComponent } from './agent-list/agent-card/agent-card.component';
import { AgentListToolbarComponent } from './agent-list/agent-list-toolbar/agent-list-toolbar.component';
import { AgentListComponent } from './agent-list/agent-list.component';
import { AgentOverviewComponent } from './agent-overview/agent-overview.component';
import { AgentPublicOverviewComponent } from './agent-public-overview/agent-public-overview.component';
import { AgentRecommendationComponent } from './agent-recommendation/agent-recommendation.component';
import { AgentFiltersComponent } from "./agent-sharing/agent-filters/agent-filters.component";
import { AgentSharingConfirmationModalComponent } from './agent-sharing/agent-sharing-confirmation-modal/agent-sharing-confirmation-modal.component';
import { AgentSharingGroupMemberListModalComponent } from './agent-sharing/agent-sharing-group-member-list-modal/agent-sharing-group-member-list-modal.component';
import { AgentSharingKeepPrivateConfirmationModalComponent } from './agent-sharing/agent-sharing-keep-private-confirmation-modal/agent-sharing-keep-private-confirmation-modal.component';
import { AgentSharingModalComponent } from './agent-sharing/agent-sharing-modal/agent-sharing-modal.component';
import { AgentWizardComponent } from './agent-wizard/agent-wizard.component';
import { AddToMyAgentsComponent } from './public-agents/add-to-my-agents/add-to-my-agents.component';

/**
 * App dependencies
 */
import { CoreModule } from '@app/core/core.module';
import { ChatStreamer } from '@app/core/services/chat/chat-streamer';
import { StreamingService } from '@app/core/services/streaming/streaming.service';
import { SharedModule } from '@app/shared/shared.module';
import { GeneAiUiModule } from '@gene-ai/ui/gene-ai-ui.module';
import { ChatModule } from '@app/chat/chat.module';
import { Streamer } from '@app/core/services/streaming/streamer';
import { ServerSentEventsClient } from '@app/core/services/server-sent-events/sse.client';
import { SSEJSClient } from '@app/core/services/server-sent-events/sse-js.client';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    AddToMyAgentsComponent,
    AgentBuilderComponent,
    AgentCardComponent,
    AgentChatNewComponent,
    AgentCreationComponent,
    AgentConversationStarterComponent,
    AgentEditComponent,
    AgentExampleComponent,
    AgentFiltersComponent,
    AgentFormComponent,
    AgentListComponent,
    AgentListPagedComponent,
    AgentListToolbarComponent,
    AgentOverviewComponent,
    AgentPublicOverviewComponent,
    AgentRecommendationComponent,
    AgentSharingConfirmationModalComponent,
    AgentSharingGroupMemberListModalComponent,
    AgentSharingKeepPrivateConfirmationModalComponent,
    AgentSharingModalComponent,
    AgentWizardComponent,
  ],
  imports: [
    ButtonModule,
    ChatModule,
    CommonModule,
    CoreModule,
    DropdownsModule,
    FormsModule,
    GeneAiUiModule,
    InputFieldsModule,
    ModalsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
  ],
  providers: [
    AgentResolver,
    ChatStreamer,
    StreamingService,
    {
      provide: ServerSentEventsClient,
      useClass: SSEJSClient
    },
    {
      provide: Streamer,
      useFactory: (streamer: ChatStreamer) => streamerFactory(streamer),
      deps: [ChatStreamer]
    }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AgentsModule { }

function streamerFactory(chatStreamer: ChatStreamer) {
  return chatStreamer;
}

